module.exports = __webpack_public_path__ + "static/media/HDMI.a941230e.png";